import { createContext, ReactNode, useContext, useMemo } from 'react'
import { useAuth } from '@/features/auth/hooks/useAuth'
import { UserChallengeRepository } from '@/repositories/UserChallengeRepository'
import { FirebaseUserChallengeRepository } from '@/repositories/UserChallengeRepositoryImpl'

interface UserChallengeContextType {
  challengeRepository: UserChallengeRepository
  isGuest: boolean
  isAuthenticated: boolean
}

const UserChallengeContext = createContext<UserChallengeContextType | undefined>(undefined)

interface UserChallengeProviderProps {
  children: ReactNode
}

export function UserChallengeProvider({ children }: UserChallengeProviderProps) {
  const { user } = useAuth()
  
  const value = useMemo(() => {
    const repository = new FirebaseUserChallengeRepository(user?.uid)
    
    if (user) {
      return {
        challengeRepository: repository,
        isGuest: false,
        isAuthenticated: true,
      }
    } else {
      return {
        challengeRepository: repository,
        isGuest: true,
        isAuthenticated: false,
      }
    }
  }, [user])

  return (
    <UserChallengeContext.Provider value={value}>
      {children}
    </UserChallengeContext.Provider>
  )
}

export function useUserChallenges() {
  const context = useContext(UserChallengeContext)
  if (context === undefined) {
    throw new Error('useUserChallenges must be used within a UserChallengeProvider')
  }
  return context
} 